export const scrollDown = () =>
	/* html */
	`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" rx="12" fill="inherit"/>
        <path d="M8 14L12 18L16 14" stroke="inherit" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
        <path opacity="0.6" d="M8 8L12 12L16 8" stroke="inherit" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `;
